<div class="core-drawer-content">
    <ng-content></ng-content>
</div>
